import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1 /* HOISTED */)
const _hoisted_2 = { class: "fixed z-10 inset-0 overflow-y-auto" }
const _hoisted_3 = { class: "flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold uppercase mb-[16px] text-[24px] tracking-[0px] leading-[30px]" }, "Blijf op de hoogte.", -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-opacity-75 text-[#060509] leading-[24px] mb-[19px]" }, "Baanbreker kijkt eerst naar jou, selecteert dan de bedrijven die bij je passen en kijkt pas als laatste naar hun vacatures.", -1 /* HOISTED */)
const _hoisted_6 = { class: "w-full flex justify-end" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Verstuur")
const _hoisted_8 = {
  key: "success",
  class: "flex items-center justify-center flex-1 w-full"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Bedankt! We hebben uw inschrijving goed ontvangen.", -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: _normalizeClass($props.cls),
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.open = !$setup.open))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2 /* CLASS */),
    _createVNode($setup["TransitionRoot"], {
      as: "template",
      show: $setup.open
    }, {
      default: _withCtx(() => [
        _createVNode($setup["Dialog"], {
          as: "div",
          class: "relative z-[60]",
          onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.open = false))
        }, {
          default: _withCtx(() => [
            _createVNode($setup["TransitionChild"], {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1 /* STABLE */
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode($setup["TransitionChild"], {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode($setup["DialogPanel"], { class: "relative bg-white rounded-[16px] px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-sm sm:w-full sm:p-[40px] md:min-w-[480px]" }, {
                      default: _withCtx(() => [
                        _createVNode($setup["XIcon"], {
                          class: "absolute h-[16px] w-[16px] right-[20px] top-[20px] cursor-pointer",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.open = false))
                        }),
                        (!$setup.success)
                          ? (_openBlock(), _createElementBlock("form", {
                              key: "form",
                              onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.onSubmit && $setup.onSubmit(...args))),
                              class: "grid"
                            }, [
                              _hoisted_4,
                              _hoisted_5,
                              (_openBlock(), _createBlock(_resolveDynamicComponent($setup.apiErrors.render()), {
                                data: $setup.apiErrors.get()
                              }, null, 8 /* PROPS */, ["data"])),
                              _createVNode($setup["FormInput"], {
                                name: "email",
                                type: "email",
                                label: "Jouw e-mailadres",
                                placeholder: "Jouw e-mailadres",
                                class: "mb-[16px]"
                              }),
                              _createVNode($setup["FormInput"], {
                                name: "first_name",
                                type: "text",
                                label: "Voornaam",
                                placeholder: "Voornaam",
                                class: "mb-[16px]"
                              }),
                              _createVNode($setup["FormInput"], {
                                name: "last_name",
                                type: "text",
                                label: "Achternaam",
                                placeholder: "Achternaam",
                                class: "mb-[16px]"
                              }),
                              _createVNode($setup["FormCheckbox"], {
                                value: false,
                                class: "mb-[16px] text-14",
                                name: "terms",
                                label: "Ik ga er mee akkoord dat Baanbreker mijn informatie verwerkt zoals omschreven in ons Privacy Beleid."
                              }),
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode($setup["Submit"], {
                                  disabled: $setup.success,
                                  loading: $setup.isSubmitting || $setup.loading
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_7
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["disabled", "loading"])
                              ])
                            ], 32 /* HYDRATE_EVENTS */))
                          : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["show"])
  ], 64 /* STABLE_FRAGMENT */))
}